<template>
    <b-row>
        <b-col>
            <b-spinner v-if="integrating"></b-spinner>
            <div v-else>
                <b-button variant="primary" @click="activate()" v-if="!isActive()">{{ $t('activate') }}</b-button>
                <b-button variant="warning" @click="deactivate()" v-if="isActive() && canDeactivate">{{ $t('deactivate') }}</b-button>
            </div>
        </b-col>
    </b-row>
</template>

<style scoped>
.integration {
    text-align: center;
    cursor: pointer;
}

.integration h4 {
    font-size: 18px;
    margin-top: 10px;
}
</style>

<script>

export default {
    name: 'ActivateFooter',
    props: {
        integration: {
            type: Object
        },
        autoIntegrate: {
            type: Boolean,
            default: true
        }
    },
    data: function() {
        return {
            integrating: false
        }
    },
    computed: {
        canDeactivate() {
            const integration = this.$store.getters.getIntegrationByID(this.integration.id)

            return integration.dependencies.length == 1 && integration.dependencies[0] == "platform"
        }
    },

    methods: {
        isActive() {
            return this.$store.getters.isIntegrationActive(this.integration.id)
        },

        async activate() {
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('integrations.activateAreYouSure'));
            if (!confirm) return

            if (this.autoIntegrate) {
                this.integrating = true;

                this.$store.dispatch("activateIntegration", this.integration).catch(err => {
                    this.$debugLog(err)
                    this.$bvModal.msgBoxOk(`${this.$t('failedToInstall')}.`)
                }).finally(() => {
                    this.integrating = false
                })

                return;
            }

            this.$emit("activate", this.integration)
        },

        async deactivate() {
            let confirm = await this.$bvModal.msgBoxConfirm(this.$t('integrations.deactivateAreYouSure'));
            if (!confirm) return

            if (this.autoIntegrate) {
                this.integrating = true;
                
                this.$store.dispatch("deactivateIntegration", this.integration).catch(err => {
                    this.$debugLog(err)

                    if (err.response) {
                        console.log(err.response)
                        if (err.response.status == 409) {
                            this.$bvModal.msgBoxOk(this.$t(err.response.data.message))
                            return
                        }
                    }

                    this.$bvModal.msgBoxOk(`${this.$t('failedToRemove')}.`)
                }).finally(() => {
                    this.integrating = false
                })

                return
            }

            this.$emit("deactivate", this.integration)
        }
    }
}
</script>
